import styled from 'styled-components';
import { theme } from '../globalStyle/global-styles';

export const SelectWrapper = styled.div`
  .label {
    span {
      color: ${theme.colours.error};
      font-size: 13px;
    }
    p {
      font-family: ${theme.fonts.Medium};
      font-size: 13px;
      line-height: 22px;
      color: ${theme.colours.black};
      margin-bottom: 4px !important;
      padding-inline-start: 12px;
      display: inline-block;
      line-height: 22px;
    }
  }

  .mantine-Select-root.hasError .mantine-Select-input {
    border: 1px solid ${theme.colours.error} !important;
  }

  .mantine-Select-item {
    &[data-selected] {
      font-size: 13px;
      background-color: ${theme.colours.blackText} !important;
      color: ${theme.colours.white};
    }
  }

  .mantine-Select-root {
    cursor: pointer;
    input {
      height: 32px !important;
      min-height: 32px !important;
      padding-block: 0;
      border-radius: 6px;
      font-size: 13px;
      color: ${theme.colours.black};
      font-family: ${theme.fonts.Regular};
      padding-inline-start: 12px;
      border: 1px solid ${theme.colours.newOutline};
      &:lang(ar) {
        text-align: right;
      }
      &:focus {
        font-size: 13px;
      }
      &::placeholder {
        color: ${theme.colours.SpanishGray};
      }
    }
    svg {
      width: 11px;
      color: ${theme.colours.black_2};
    }

    .mantine-Select-rightSection {
      &:lang(ar) {
        left: 0;
        right: auto;
      }
    }
  }
`;
